import React, { useState } from "react";
import { Button, Drawer, Flex, Form, Input, Typography } from "@payping/web-components";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Close } from "@payping/icons";
import { ValidPersianName } from "@payping/utils/validation";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { isPersonalDisable } from "@/mobile/Settings/Personal/Edit/isPersonalDisable";
import { DashboardRoutes } from "@/router";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { settingsPersonalAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsPersonalAtom, (val) => val.mobileFormEdit);

const MobileEditPersonalLastName: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [form] = Form.useForm();
  const { t } = useAppTranslation();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const lastNameApi = useAppSelector((state) => state.user.personalInfo?.lastName);

  const [lastName, setLastName] = useState<string | undefined>();

  // Custom Hooks
  const { handleNavigationURL } = useHandleNavigationURL();
  const { saveToRedux } = useSaveToRedux();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        title={`${t("edit")} / ${t("lastName")}`}
        height={"100%"}
        placement={"bottom"}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <Form
            onFinish={() =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditPersonal.fatherName.url,
                fieldName: "lastName",
                fieldValue: lastName,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ lastName: mobileFormEditState.lastName ?? lastNameApi }}
          >
            <Form.Item
              name="lastName"
              rules={[
                {
                  validator(_, value): Promise<void> {
                    if (ValidPersianName(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("profile.validLastName")));
                  },
                },
                { required: true },
              ]}
            >
              <Input
                value={lastName}
                placeholder={t("mobileEditPersonal.enterName")}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                disabled={isPersonalDisable()}
              />
            </Form.Item>
          </Form>

          <Typography.Text type={"secondary"}>
            {t("settings.personal.instructions.firstNameAndLastName")}
          </Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditPersonalLastName;
